// A2F-764: hero block at the top of the left column.
//
// Pre-headline pill + headline + subhead. Headline mirrors v1 voice
// ("Your Chrona ribbon, *ready for Word.*") with the italic accent in
// Chrona orange on the second half. Subhead is the only place we
// describe the page; we never tell the user "look at the document on
// the right" — the user can see it.

export function ProV2Hero() {
  return (
    <section className="mb-6">
      <div className="inline-block rounded-full bg-brand-orange/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-brand-orange mb-3">
        Chrona Pro · $99/year
      </div>
      <h1 className="text-3xl md:text-[34px] font-medium leading-[1.15] text-brand-charcoal tracking-tight max-w-2xl">
        Your Chrona ribbon,{' '}
        <span className="font-serif italic text-brand-orange font-normal">
          ready for Word.
        </span>
      </h1>
      <p className="text-sm text-slate-600 mt-3 max-w-xl leading-relaxed">
        Set the formatting, regulatory packs, and rules your team's writing
        follows. Watch your ribbon take shape as you go.
      </p>
    </section>
  )
}
